import { createApp, h } from 'vue'
import { App, plugin, Link } from '@inertiajs/inertia-vue3'

import { InertiaProgress } from '@inertiajs/progress'

import route from 'ziggy-js'

import { createI18n } from 'vue-i18n'
import Locale from './vue-i18n-locales.generated'
import Layout from './Partials/Layout'
import { Inertia } from '@inertiajs/inertia'

let i18n = createI18n({
  locale: window.lang,
  fallbackLocale: 'en',
  messages: Locale,
})

const files = require.context('./components', true, /\.vue$/i)

window.addEventListener('load', () => {
  const globalApp = createApp({}).mixin({
    methods: {
      route,
    },
  })

  files
    .keys()
    .forEach((key) => globalApp.component(key.split('/').pop().split('.')[0], files(key).default))

  globalApp.use(i18n).mount('#global-app')

  const el = document.getElementById('app')

  if (el) {
    InertiaProgress.init({
      color: '#FC2B5C',
    })

    const app = createApp({
      render: () =>
        h(App, {
          initialPage: JSON.parse(el.dataset.page),
          resolveComponent: (name) =>
            import(`./Pages/${name}`).then(({ default: page }) => {
              page.layout = page.layout === undefined ? Layout : page.layout
              return page
            }),
        }),
    })
      .component('InertiaLink', Link)
      .mixin({
        methods: {
          route,
        },
      })
      .use(i18n)
      .use(plugin)

    app.mount(el)
  }

  Inertia.on('finish', (event) => {
    window.Intercom('update')
  })
})
